/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import React from 'react';
import { Typography, styled } from '@mui/material';

const StyledTypography = styled(Typography)(({ theme }) => ({
  display: 'flex',
  cursor: 'pointer',
  margin: '16px 0 8px 0',
  [theme.breakpoints.down('sm')]: {
    margin: '16px auto 8px auto',
  },
}));

interface ActionButtonProps {
  onClick: () => void;
  title: string;
  'data-testid': string;
  sx?: React.CSSProperties;
}
export const ActionButton: React.FC<ActionButtonProps> = ({ onClick, title, sx, ...props }) => {
  return (
    <StyledTypography
      variant='link'
      color='inherit'
      onClick={onClick}
      data-testid={props['data-testid']}
      sx={sx}
    >
      {title}
    </StyledTypography>
  );
};
